const calculateValue = (value) => (value !== '' && value !== null ? Number(value) : null);

export { calculateValue };
